export type SpacingToken =
  | 0
  | 0.5
  | 1
  | 1.5
  | 2
  | 2.5
  | 3
  | 3.5
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 14
  | 16
  | 20
  | 24
  | 28
  | 32
  | 36
  | 40
  | 44
  | 48
  | 52
  | 56
  | 60
  | 64
  | 72
  | 80
  | 96;

const SPACING_LOOKUP: Record<string, Record<number | string, string>> = {
  p: { 0: 'p-0', 0.5: 'p-0.5', 1: 'p-1', 1.5: 'p-1.5', 2: 'p-2', 2.5: 'p-2.5', 3: 'p-3', 3.5: 'p-3.5', 4: 'p-4', 5: 'p-5', 6: 'p-6', 7: 'p-7', 8: 'p-8', 9: 'p-9', 10: 'p-10', 11: 'p-11', 12: 'p-12', 14: 'p-14', 16: 'p-16', 20: 'p-20', 24: 'p-24', 28: 'p-28', 32: 'p-32', 36: 'p-36', 40: 'p-40', 44: 'p-44', 48: 'p-48', 52: 'p-52', 56: 'p-56', 60: 'p-60', 64: 'p-64', 72: 'p-72', 80: 'p-80', 96: 'p-96' },
  px: { 0: 'px-0', 0.5: 'px-0.5', 1: 'px-1', 1.5: 'px-1.5', 2: 'px-2', 2.5: 'px-2.5', 3: 'px-3', 3.5: 'px-3.5', 4: 'px-4', 5: 'px-5', 6: 'px-6', 7: 'px-7', 8: 'px-8', 9: 'px-9', 10: 'px-10', 11: 'px-11', 12: 'px-12', 14: 'px-14', 16: 'px-16', 20: 'px-20', 24: 'px-24', 28: 'px-28', 32: 'px-32', 36: 'px-36', 40: 'px-40', 44: 'px-44', 48: 'px-48', 52: 'px-52', 56: 'px-56', 60: 'px-60', 64: 'px-64', 72: 'px-72', 80: 'px-80', 96: 'px-96' },
  py: { 0: 'py-0', 0.5: 'py-0.5', 1: 'py-1', 1.5: 'py-1.5', 2: 'py-2', 2.5: 'py-2.5', 3: 'py-3', 3.5: 'py-3.5', 4: 'py-4', 5: 'py-5', 6: 'py-6', 7: 'py-7', 8: 'py-8', 9: 'py-9', 10: 'py-10', 11: 'py-11', 12: 'py-12', 14: 'py-14', 16: 'py-16', 20: 'py-20', 24: 'py-24', 28: 'py-28', 32: 'py-32', 36: 'py-36', 40: 'py-40', 44: 'py-44', 48: 'py-48', 52: 'py-52', 56: 'py-56', 60: 'py-60', 64: 'py-64', 72: 'py-72', 80: 'py-80', 96: 'py-96' },
  pt: { 0: 'pt-0', 0.5: 'pt-0.5', 1: 'pt-1', 1.5: 'pt-1.5', 2: 'pt-2', 2.5: 'pt-2.5', 3: 'pt-3', 3.5: 'pt-3.5', 4: 'pt-4', 5: 'pt-5', 6: 'pt-6', 7: 'pt-7', 8: 'pt-8', 9: 'pt-9', 10: 'pt-10', 11: 'pt-11', 12: 'pt-12', 14: 'pt-14', 16: 'pt-16', 20: 'pt-20', 24: 'pt-24', 28: 'pt-28', 32: 'pt-32', 36: 'pt-36', 40: 'pt-40', 44: 'pt-44', 48: 'pt-48', 52: 'pt-52', 56: 'pt-56', 60: 'pt-60', 64: 'pt-64', 72: 'pt-72', 80: 'pt-80', 96: 'pt-96' },
  pb: { 0: 'pb-0', 0.5: 'pb-0.5', 1: 'pb-1', 1.5: 'pb-1.5', 2: 'pb-2', 2.5: 'pb-2.5', 3: 'pb-3', 3.5: 'pb-3.5', 4: 'pb-4', 5: 'pb-5', 6: 'pb-6', 7: 'pb-7', 8: 'pb-8', 9: 'pb-9', 10: 'pb-10', 11: 'pb-11', 12: 'pb-12', 14: 'pb-14', 16: 'pb-16', 20: 'pb-20', 24: 'pb-24', 28: 'pb-28', 32: 'pb-32', 36: 'pb-36', 40: 'pb-40', 44: 'pb-44', 48: 'pb-48', 52: 'pb-52', 56: 'pb-56', 60: 'pb-60', 64: 'pb-64', 72: 'pb-72', 80: 'pb-80', 96: 'pb-96' },
  pl: { 0: 'pl-0', 0.5: 'pl-0.5', 1: 'pl-1', 1.5: 'pl-1.5', 2: 'pl-2', 2.5: 'pl-2.5', 3: 'pl-3', 3.5: 'pl-3.5', 4: 'pl-4', 5: 'pl-5', 6: 'pl-6', 7: 'pl-7', 8: 'pl-8', 9: 'pl-9', 10: 'pl-10', 11: 'pl-11', 12: 'pl-12', 14: 'pl-14', 16: 'pl-16', 20: 'pl-20', 24: 'pl-24', 28: 'pl-28', 32: 'pl-32', 36: 'pl-36', 40: 'pl-40', 44: 'pl-44', 48: 'pl-48', 52: 'pl-52', 56: 'pl-56', 60: 'pl-60', 64: 'pl-64', 72: 'pl-72', 80: 'pl-80', 96: 'pl-96' },
  pr: { 0: 'pr-0', 0.5: 'pr-0.5', 1: 'pr-1', 1.5: 'pr-1.5', 2: 'pr-2', 2.5: 'pr-2.5', 3: 'pr-3', 3.5: 'pr-3.5', 4: 'pr-4', 5: 'pr-5', 6: 'pr-6', 7: 'pr-7', 8: 'pr-8', 9: 'pr-9', 10: 'pr-10', 11: 'pr-11', 12: 'pr-12', 14: 'pr-14', 16: 'pr-16', 20: 'pr-20', 24: 'pr-24', 28: 'pr-28', 32: 'pr-32', 36: 'pr-36', 40: 'pr-40', 44: 'pr-44', 48: 'pr-48', 52: 'pr-52', 56: 'pr-56', 60: 'pr-60', 64: 'pr-64', 72: 'pr-72', 80: 'pr-80', 96: 'pr-96' },
  m: { 0: 'm-0', 0.5: 'm-0.5', 1: 'm-1', 1.5: 'm-1.5', 2: 'm-2', 2.5: 'm-2.5', 3: 'm-3', 3.5: 'm-3.5', 4: 'm-4', 5: 'm-5', 6: 'm-6', 7: 'm-7', 8: 'm-8', 9: 'm-9', 10: 'm-10', 11: 'm-11', 12: 'm-12', 14: 'm-14', 16: 'm-16', 20: 'm-20', 24: 'm-24', 28: 'm-28', 32: 'm-32', 36: 'm-36', 40: 'm-40', 44: 'm-44', 48: 'm-48', 52: 'm-52', 56: 'm-56', 60: 'm-60', 64: 'm-64', 72: 'm-72', 80: 'm-80', 96: 'm-96' },
  mx: { 0: 'mx-0', 0.5: 'mx-0.5', 1: 'mx-1', 1.5: 'mx-1.5', 2: 'mx-2', 2.5: 'mx-2.5', 3: 'mx-3', 3.5: 'mx-3.5', 4: 'mx-4', 5: 'mx-5', 6: 'mx-6', 7: 'mx-7', 8: 'mx-8', 9: 'mx-9', 10: 'mx-10', 11: 'mx-11', 12: 'mx-12', 14: 'mx-14', 16: 'mx-16', 20: 'mx-20', 24: 'mx-24', 28: 'mx-28', 32: 'mx-32', 36: 'mx-36', 40: 'mx-40', 44: 'mx-44', 48: 'mx-48', 52: 'mx-52', 56: 'mx-56', 60: 'mx-60', 64: 'mx-64', 72: 'mx-72', 80: 'mx-80', 96: 'mx-96' },
  my: { 0: 'my-0', 0.5: 'my-0.5', 1: 'my-1', 1.5: 'my-1.5', 2: 'my-2', 2.5: 'my-2.5', 3: 'my-3', 3.5: 'my-3.5', 4: 'my-4', 5: 'my-5', 6: 'my-6', 7: 'my-7', 8: 'my-8', 9: 'my-9', 10: 'my-10', 11: 'my-11', 12: 'my-12', 14: 'my-14', 16: 'my-16', 20: 'my-20', 24: 'my-24', 28: 'my-28', 32: 'my-32', 36: 'my-36', 40: 'my-40', 44: 'my-44', 48: 'my-48', 52: 'my-52', 56: 'my-56', 60: 'my-60', 64: 'my-64', 72: 'my-72', 80: 'my-80', 96: 'my-96' },
  mt: { 0: 'mt-0', 0.5: 'mt-0.5', 1: 'mt-1', 1.5: 'mt-1.5', 2: 'mt-2', 2.5: 'mt-2.5', 3: 'mt-3', 3.5: 'mt-3.5', 4: 'mt-4', 5: 'mt-5', 6: 'mt-6', 7: 'mt-7', 8: 'mt-8', 9: 'mt-9', 10: 'mt-10', 11: 'mt-11', 12: 'mt-12', 14: 'mt-14', 16: 'mt-16', 20: 'mt-20', 24: 'mt-24', 28: 'mt-28', 32: 'mt-32', 36: 'mt-36', 40: 'mt-40', 44: 'mt-44', 48: 'mt-48', 52: 'mt-52', 56: 'mt-56', 60: 'mt-60', 64: 'mt-64', 72: 'mt-72', 80: 'mt-80', 96: 'mt-96' },
  mb: { 0: 'mb-0', 0.5: 'mb-0.5', 1: 'mb-1', 1.5: 'mb-1.5', 2: 'mb-2', 2.5: 'mb-2.5', 3: 'mb-3', 3.5: 'mb-3.5', 4: 'mb-4', 5: 'mb-5', 6: 'mb-6', 7: 'mb-7', 8: 'mb-8', 9: 'mb-9', 10: 'mb-10', 11: 'mb-11', 12: 'mb-12', 14: 'mb-14', 16: 'mb-16', 20: 'mb-20', 24: 'mb-24', 28: 'mb-28', 32: 'mb-32', 36: 'mb-36', 40: 'mb-40', 44: 'mb-44', 48: 'mb-48', 52: 'mb-52', 56: 'mb-56', 60: 'mb-60', 64: 'mb-64', 72: 'mb-72', 80: 'mb-80', 96: 'mb-96' },
  gap: { 0: 'gap-0', 0.5: 'gap-0.5', 1: 'gap-1', 1.5: 'gap-1.5', 2: 'gap-2', 2.5: 'gap-2.5', 3: 'gap-3', 3.5: 'gap-3.5', 4: 'gap-4', 5: 'gap-5', 6: 'gap-6', 7: 'gap-7', 8: 'gap-8', 9: 'gap-9', 10: 'gap-10', 11: 'gap-11', 12: 'gap-12', 14: 'gap-14', 16: 'gap-16', 20: 'gap-20', 24: 'gap-24', 28: 'gap-28', 32: 'gap-32', 36: 'gap-36', 40: 'gap-40', 44: 'gap-44', 48: 'gap-48', 52: 'gap-52', 56: 'gap-56', 60: 'gap-60', 64: 'gap-64', 72: 'gap-72', 80: 'gap-80', 96: 'gap-96' },
  'gap-x': { 0: 'gap-x-0', 0.5: 'gap-x-0.5', 1: 'gap-x-1', 1.5: 'gap-x-1.5', 2: 'gap-x-2', 2.5: 'gap-x-2.5', 3: 'gap-x-3', 3.5: 'gap-x-3.5', 4: 'gap-x-4', 5: 'gap-x-5', 6: 'gap-x-6', 7: 'gap-x-7', 8: 'gap-x-8', 9: 'gap-x-9', 10: 'gap-x-10', 11: 'gap-x-11', 12: 'gap-x-12', 14: 'gap-x-14', 16: 'gap-x-16', 20: 'gap-x-20', 24: 'gap-x-24', 28: 'gap-x-28', 32: 'gap-x-32', 36: 'gap-x-36', 40: 'gap-x-40', 44: 'gap-x-44', 48: 'gap-x-48', 52: 'gap-x-52', 56: 'gap-x-56', 60: 'gap-x-60', 64: 'gap-x-64', 72: 'gap-x-72', 80: 'gap-x-80', 96: 'gap-x-96' },
  'gap-y': { 0: 'gap-y-0', 0.5: 'gap-y-0.5', 1: 'gap-y-1', 1.5: 'gap-y-1.5', 2: 'gap-y-2', 2.5: 'gap-y-2.5', 3: 'gap-y-3', 3.5: 'gap-y-3.5', 4: 'gap-y-4', 5: 'gap-y-5', 6: 'gap-y-6', 7: 'gap-y-7', 8: 'gap-y-8', 9: 'gap-y-9', 10: 'gap-y-10', 11: 'gap-y-11', 12: 'gap-y-12', 14: 'gap-y-14', 16: 'gap-y-16', 20: 'gap-y-20', 24: 'gap-y-24', 28: 'gap-y-28', 32: 'gap-y-32', 36: 'gap-y-36', 40: 'gap-y-40', 44: 'gap-y-44', 48: 'gap-y-48', 52: 'gap-y-52', 56: 'gap-y-56', 60: 'gap-y-60', 64: 'gap-y-64', 72: 'gap-y-72', 80: 'gap-y-80', 96: 'gap-y-96' },
};

export const parseSpacing = (
  value: SpacingToken | undefined,
  prefix: string,
): string => {
  if (value === undefined) return '';

  return SPACING_LOOKUP[prefix]?.[value] || '';
};

export type Breakpoint = 'default' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';

export type ResponsiveCols = Partial<Record<Breakpoint, number | string>>;

const COLS_MAP: Record<string, Record<Breakpoint, string>> = {
  1: {
    default: 'grid-cols-1',
    sm: 'sm:grid-cols-1',
    md: 'md:grid-cols-1',
    lg: 'lg:grid-cols-1',
    xl: 'xl:grid-cols-1',
    '2xl': '2xl:grid-cols-1',
  },
  2: {
    default: 'grid-cols-2',
    sm: 'sm:grid-cols-2',
    md: 'md:grid-cols-2',
    lg: 'lg:grid-cols-2',
    xl: 'xl:grid-cols-2',
    '2xl': '2xl:grid-cols-1',
  },
  3: {
    default: 'grid-cols-3',
    sm: 'sm:grid-cols-3',
    md: 'md:grid-cols-3',
    lg: 'lg:grid-cols-3',
    xl: 'xl:grid-cols-3',
    '2xl': '2xl:grid-cols-1',
  },
  4: {
    default: 'grid-cols-4',
    sm: 'sm:grid-cols-4',
    md: 'md:grid-cols-4',
    lg: 'lg:grid-cols-4',
    xl: 'xl:grid-cols-4',
    '2xl': '2xl:grid-cols-1',
  },
  5: {
    default: 'grid-cols-5',
    sm: 'sm:grid-cols-5',
    md: 'md:grid-cols-5',
    lg: 'lg:grid-cols-5',
    xl: 'xl:grid-cols-5',
    '2xl': '2xl:grid-cols-1',
  },
  6: {
    default: 'grid-cols-6',
    sm: 'sm:grid-cols-6',
    md: 'md:grid-cols-6',
    lg: 'lg:grid-cols-6',
    xl: 'xl:grid-cols-6',
    '2xl': '2xl:grid-cols-1',
  },
};

const ROWS_MAP: Record<string, Record<Breakpoint, string>> = {
  1: {
    default: 'grid-rows-1',
    sm: 'sm:grid-rows-1',
    md: 'md:grid-rows-1',
    lg: 'lg:grid-rows-1',
    xl: 'xl:grid-rows-1',
    '2xl': '2xl:grid-rows-1',
  },
  2: {
    default: 'grid-rows-2',
    sm: 'sm:grid-rows-2',
    md: 'md:grid-rows-2',
    lg: 'lg:grid-rows-2',
    xl: 'xl:grid-rows-2',
    '2xl': '2xl:grid-rows-1',
  },
  3: {
    default: 'grid-rows-3',
    sm: 'sm:grid-rows-3',
    md: 'md:grid-rows-3',
    lg: 'lg:grid-rows-3',
    xl: 'xl:grid-rows-3',
    '2xl': '2xl:grid-rows-1',
  },
  4: {
    default: 'grid-rows-4',
    sm: 'sm:grid-rows-4',
    md: 'md:grid-rows-4',
    lg: 'lg:grid-rows-4',
    xl: 'xl:grid-rows-4',
    '2xl': '2xl:grid-rows-1',
  },
  5: {
    default: 'grid-rows-5',
    sm: 'sm:grid-rows-5',
    md: 'md:grid-rows-5',
    lg: 'lg:grid-rows-5',
    xl: 'xl:grid-rows-5',
    '2xl': '2xl:grid-rows-1',
  },
  6: {
    default: 'grid-rows-6',
    sm: 'sm:grid-rows-6',
    md: 'md:grid-rows-6',
    lg: 'lg:grid-rows-6',
    xl: 'xl:grid-rows-6',
    '2xl': '2xl:grid-rows-1',
  },
};

export const parseResponsiveCols = (
  cols: number | string | ResponsiveCols,
  prefix: 'grid-cols' | 'grid-rows',
): string => {
  const map = prefix === 'grid-cols' ? COLS_MAP : ROWS_MAP;

  if (
    typeof cols === 'number' ||
    (typeof cols === 'string' && !cols.includes(':'))
  ) {
    return map[cols.toString()]?.default || '';
  }

  return Object.entries(cols)
    .map(([bp, val]) => {
      return map[val.toString()]?.[bp as Breakpoint] || '';
    })
    .join(' ');
};

export type ResponsiveProp<T> = T | Partial<Record<Breakpoint, T>>;

export const parseResponsive = <T extends string | number | boolean>(
  value: ResponsiveProp<T> | undefined,
  map: Record<string | number, Record<Breakpoint, string>>,
): string => {
  if (value === undefined || value === (false as any)) return '';

  if (typeof value === 'object' && value !== null) {
    return Object.entries(value)
      .map(([bp, val]) => map[val.toString()]?.[bp as Breakpoint] || '')
      .filter(Boolean)
      .join(' ');
  }

  const strValue = value.toString();

  if (strValue.includes(' ')) {
    return strValue
      .split(' ')
      .map((item) => {
        if (item.includes(':')) {
          const [bp, val] = item.split(':');

          return map[val]?.[bp as Breakpoint] || '';
        }

        return map[item]?.default || '';
      })
      .filter(Boolean)
      .join(' ');
  }

  if (strValue.includes(':')) {
    const [bp, val] = strValue.split(':');

    return map[val]?.[bp as Breakpoint] || '';
  }

  return map[strValue]?.default || '';
};

const MAX_WIDTH_MAP: Record<string, Record<Breakpoint, string>> = {
  sm: { default: 'max-w-sm', sm: 'sm:max-w-sm', md: 'md:max-w-sm', lg: 'lg:max-w-sm', xl: 'xl:max-w-sm', '2xl': '2xl:max-w-sm' },
  md: { default: 'max-w-md', sm: 'sm:max-w-md', md: 'md:max-w-md', lg: 'lg:max-w-md', xl: 'xl:max-w-md', '2xl': '2xl:max-w-md' },
  lg: { default: 'max-w-lg', sm: 'sm:max-w-lg', md: 'md:max-w-lg', lg: 'lg:max-w-lg', xl: 'xl:max-w-lg', '2xl': '2xl:max-w-lg' },
  xl: { default: 'max-w-xl', sm: 'sm:max-w-xl', md: 'md:max-w-xl', lg: 'lg:max-w-xl', xl: 'xl:max-w-xl', '2xl': '2xl:max-w-xl' },
  '2xl': { default: 'max-w-2xl', sm: 'sm:max-w-2xl', md: 'md:max-w-2xl', lg: 'lg:max-w-2xl', xl: 'xl:max-w-2xl', '2xl': '2xl:max-w-2xl' },
  '3xl': { default: 'max-w-3xl', sm: 'sm:max-w-3xl', md: 'md:max-w-3xl', lg: 'lg:max-w-3xl', xl: 'xl:max-w-3xl', '2xl': '2xl:max-w-3xl' },
  '4xl': { default: 'max-w-4xl', sm: 'sm:max-w-4xl', md: 'md:max-w-4xl', lg: 'lg:max-w-4xl', xl: 'xl:max-w-4xl', '2xl': '2xl:max-w-4xl' },
  '5xl': { default: 'max-w-5xl', sm: 'sm:max-w-5xl', md: 'md:max-w-5xl', lg: 'lg:max-w-5xl', xl: 'xl:max-w-5xl', '2xl': '2xl:max-w-5xl' },
  '6xl': { default: 'max-w-6xl', sm: 'sm:max-w-6xl', md: 'md:max-w-6xl', lg: 'lg:max-w-6xl', xl: 'xl:max-w-6xl', '2xl': '2xl:max-w-6xl' },
  '7xl': { default: 'max-w-7xl', sm: 'sm:max-w-7xl', md: 'md:max-w-7xl', lg: 'lg:max-w-7xl', xl: 'xl:max-w-7xl', '2xl': '2xl:max-w-7xl' },
  full: { default: 'max-w-full', sm: 'sm:max-w-full', md: 'md:max-w-full', lg: 'lg:max-w-full', xl: 'xl:max-w-full', '2xl': '2xl:max-w-full' },
  prose: { default: 'max-w-prose', sm: 'sm:max-w-prose', md: 'md:max-w-prose', lg: 'lg:max-w-prose', xl: 'xl:max-w-prose', '2xl': '2xl:max-w-prose' },
  screen: { default: 'max-w-screen', sm: 'sm:max-w-screen', md: 'md:max-w-screen', lg: 'lg:max-w-screen', xl: 'xl:max-w-screen', '2xl': '2xl:max-w-screen' },
};

const SHADOW_MAP: Record<string, Record<Breakpoint, string>> = {
  none: { default: 'shadow-none', sm: 'sm:shadow-none', md: 'md:shadow-none', lg: 'lg:shadow-none', xl: 'xl:shadow-none', '2xl': '2xl:shadow-none' },
  sm: { default: 'shadow-sm', sm: 'sm:shadow-sm', md: 'md:shadow-sm', lg: 'lg:shadow-sm', xl: 'xl:shadow-sm', '2xl': '2xl:shadow-sm' },
  md: { default: 'shadow-md', sm: 'sm:shadow-md', md: 'md:shadow-md', lg: 'lg:shadow-md', xl: 'xl:shadow-md', '2xl': '2xl:shadow-md' },
  lg: { default: 'shadow-lg', sm: 'sm:shadow-lg', md: 'md:shadow-lg', lg: 'lg:shadow-lg', xl: 'xl:shadow-lg', '2xl': '2xl:shadow-lg' },
  xl: { default: 'shadow-xl', sm: 'sm:shadow-xl', md: 'md:shadow-xl', lg: 'lg:shadow-xl', xl: 'xl:shadow-xl', '2xl': '2xl:shadow-xl' },
  '2xl': { default: 'shadow-2xl', sm: 'sm:shadow-2xl', md: 'md:shadow-2xl', lg: 'lg:shadow-2xl', xl: 'xl:shadow-2xl', '2xl': '2xl:shadow-2xl' },
  inner: { default: 'shadow-inner', sm: 'sm:shadow-inner', md: 'md:shadow-inner', lg: 'lg:shadow-inner', xl: 'xl:shadow-inner', '2xl': '2xl:shadow-inner' },
};

const BLUR_MAP: Record<string, Record<Breakpoint, string>> = {
  none: { default: 'backdrop-blur-none', sm: 'sm:backdrop-blur-none', md: 'md:backdrop-blur-none', lg: 'lg:backdrop-blur-none', xl: 'xl:backdrop-blur-none', '2xl': '2xl:backdrop-blur-none' },
  sm: { default: 'backdrop-blur-sm', sm: 'sm:backdrop-blur-sm', md: 'md:backdrop-blur-sm', lg: 'lg:backdrop-blur-sm', xl: 'xl:backdrop-blur-sm', '2xl': '2xl:backdrop-blur-sm' },
  md: { default: 'backdrop-blur-md', sm: 'sm:backdrop-blur-md', md: 'md:backdrop-blur-md', lg: 'lg:backdrop-blur-md', xl: 'xl:backdrop-blur-md', '2xl': '2xl:backdrop-blur-md' },
  lg: { default: 'backdrop-blur-lg', sm: 'sm:backdrop-blur-lg', md: 'md:backdrop-blur-lg', lg: 'lg:backdrop-blur-lg', xl: 'xl:backdrop-blur-lg', '2xl': '2xl:backdrop-blur-lg' },
  xl: { default: 'backdrop-blur-xl', sm: 'sm:backdrop-blur-xl', md: 'md:backdrop-blur-xl', lg: 'lg:backdrop-blur-xl', xl: 'xl:backdrop-blur-xl', '2xl': '2xl:backdrop-blur-xl' },
};

const BORDER_RADIUS_MAP: Record<string, Record<Breakpoint, string>> = {
  none: { default: 'rounded-none', sm: 'sm:rounded-none', md: 'md:rounded-none', lg: 'lg:rounded-none', xl: 'xl:rounded-none', '2xl': '2xl:rounded-none' },
  sm: { default: 'rounded-sm', sm: 'sm:rounded-sm', md: 'md:rounded-sm', lg: 'lg:rounded-sm', xl: 'xl:rounded-sm', '2xl': '2xl:rounded-sm' },
  md: { default: 'rounded-md', sm: 'sm:rounded-md', md: 'md:rounded-md', lg: 'lg:rounded-md', xl: 'xl:rounded-md', '2xl': '2xl:rounded-md' },
  lg: { default: 'rounded-lg', sm: 'sm:rounded-lg', md: 'md:rounded-lg', lg: 'lg:rounded-lg', xl: 'xl:rounded-lg', '2xl': '2xl:rounded-lg' },
  xl: { default: 'rounded-xl', sm: 'sm:rounded-xl', md: 'md:rounded-xl', lg: 'lg:rounded-xl', xl: 'xl:rounded-xl', '2xl': '2xl:rounded-xl' },
  '2xl': { default: 'rounded-2xl', sm: 'sm:rounded-2xl', md: 'md:rounded-2xl', lg: 'lg:rounded-2xl', xl: 'xl:rounded-2xl', '2xl': '2xl:rounded-2xl' },
  full: { default: 'rounded-full', sm: 'sm:rounded-full', md: 'md:rounded-full', lg: 'lg:rounded-full', xl: 'xl:rounded-full', '2xl': '2xl:rounded-full' },
};

const ALIGN_MAP: Record<string, Record<Breakpoint, string>> = {
  start: { default: 'items-start', sm: 'sm:items-start', md: 'md:items-start', lg: 'lg:items-start', xl: 'xl:items-start', '2xl': '2xl:items-start' },
  center: { default: 'items-center', sm: 'sm:items-center', md: 'md:items-center', lg: 'lg:items-center', xl: 'xl:items-center', '2xl': '2xl:items-center' },
  end: { default: 'items-end', sm: 'sm:items-end', md: 'md:items-end', lg: 'lg:items-end', xl: 'xl:items-end', '2xl': '2xl:items-end' },
  baseline: { default: 'items-baseline', sm: 'sm:items-baseline', md: 'md:items-baseline', lg: 'lg:items-baseline', xl: 'xl:items-baseline', '2xl': '2xl:items-baseline' },
  stretch: { default: 'items-stretch', sm: 'sm:items-stretch', md: 'md:items-stretch', lg: 'lg:items-stretch', xl: 'xl:items-stretch', '2xl': '2xl:items-stretch' },
};

const JUSTIFY_MAP: Record<string, Record<Breakpoint, string>> = {
  start: { default: 'justify-start', sm: 'sm:justify-start', md: 'md:justify-start', lg: 'lg:justify-start', xl: 'xl:justify-start', '2xl': '2xl:justify-start' },
  center: { default: 'justify-center', sm: 'sm:justify-center', md: 'md:justify-center', lg: 'lg:justify-center', xl: 'xl:justify-center', '2xl': '2xl:justify-center' },
  end: { default: 'justify-end', sm: 'sm:justify-end', md: 'md:justify-end', lg: 'lg:justify-end', xl: 'xl:justify-end', '2xl': '2xl:justify-end' },
  between: { default: 'justify-between', sm: 'sm:justify-between', md: 'md:justify-between', lg: 'lg:justify-between', xl: 'xl:justify-between', '2xl': '2xl:justify-between' },
  around: { default: 'justify-around', sm: 'sm:justify-around', md: 'md:justify-around', lg: 'lg:justify-around', xl: 'xl:justify-around', '2xl': '2xl:justify-around' },
  evenly: { default: 'justify-evenly', sm: 'sm:justify-evenly', md: 'md:justify-evenly', lg: 'lg:justify-evenly', xl: 'xl:justify-evenly', '2xl': '2xl:justify-evenly' },
};

const BACKGROUND_MAP = {
  surface: 'bg-[var(--surface)]',
  primary: 'bg-white/80 dark:bg-zinc-900/80',
  secondary: 'bg-zinc-100/80 dark:bg-zinc-800/80',
  accent: 'bg-teal-600/10 dark:bg-teal-400/10',
  transparent: 'bg-transparent',
};

const BORDER_MAP = {
  divider: 'border-divider',
  primary: 'border-primary',
  secondary: 'border-secondary',
};

const POSITION_MAP: Record<string, Record<Breakpoint, string>> = {
  static: { default: 'static', sm: 'sm:static', md: 'md:static', lg: 'lg:static', xl: 'xl:static', '2xl': '2xl:static' },
  fixed: { default: 'fixed', sm: 'sm:fixed', md: 'md:fixed', lg: 'lg:fixed', xl: 'xl:fixed', '2xl': '2xl:fixed' },
  absolute: { default: 'absolute', sm: 'sm:absolute', md: 'md:absolute', lg: 'lg:absolute', xl: 'xl:absolute', '2xl': '2xl:absolute' },
  sticky: { default: 'sticky', sm: 'sm:sticky', md: 'md:sticky', lg: 'lg:sticky', xl: 'xl:sticky', '2xl': '2xl:sticky' },
  relative: { default: 'relative', sm: 'sm:relative', md: 'md:relative', lg: 'lg:relative', xl: 'xl:relative', '2xl': '2xl:relative' },
};

const OVERFLOW_MAP: Record<string, Record<Breakpoint, string>> = {
  auto: { default: 'overflow-auto', sm: 'sm:overflow-auto', md: 'md:overflow-auto', lg: 'lg:overflow-auto', xl: 'xl:overflow-auto', '2xl': '2xl:overflow-auto' },
  hidden: { default: 'overflow-hidden', sm: 'sm:overflow-hidden', md: 'md:overflow-hidden', lg: 'lg:overflow-hidden', xl: 'xl:overflow-hidden', '2xl': '2xl:overflow-hidden' },
  visible: { default: 'overflow-visible', sm: 'sm:overflow-visible', md: 'md:overflow-visible', lg: 'lg:overflow-visible', xl: 'xl:overflow-visible', '2xl': '2xl:overflow-visible' },
  scroll: { default: 'overflow-scroll', sm: 'sm:overflow-scroll', md: 'md:overflow-scroll', lg: 'lg:overflow-scroll', xl: 'xl:overflow-scroll', '2xl': '2xl:overflow-scroll' },
};

const Z_INDEX_MAP: Record<string, Record<Breakpoint, string>> = {
  0: { default: 'z-0', sm: 'sm:z-0', md: 'md:z-0', lg: 'lg:z-0', xl: 'xl:z-0', '2xl': '2xl:z-0' },
  10: { default: 'z-10', sm: 'sm:z-10', md: 'md:z-10', lg: 'lg:z-10', xl: 'xl:z-10', '2xl': '2xl:z-10' },
  20: { default: 'z-20', sm: 'sm:z-20', md: 'md:z-20', lg: 'lg:z-20', xl: 'xl:z-20', '2xl': '2xl:z-20' },
  30: { default: 'z-30', sm: 'sm:z-30', md: 'md:z-30', lg: 'lg:z-30', xl: 'xl:z-30', '2xl': '2xl:z-30' },
  40: { default: 'z-40', sm: 'sm:z-40', md: 'md:z-40', lg: 'lg:z-40', xl: 'xl:z-40', '2xl': '2xl:z-40' },
  50: { default: 'z-50', sm: 'sm:z-50', md: 'md:z-50', lg: 'lg:z-50', xl: 'xl:z-50', '2xl': '2xl:z-50' },
  auto: { default: 'z-auto', sm: 'sm:z-auto', md: 'md:z-auto', lg: 'lg:z-auto', xl: 'xl:z-auto', '2xl': '2xl:z-auto' },
};

const OPACITY_MAP: Record<string, Record<Breakpoint, string>> = {
  0: { default: 'opacity-0', sm: 'sm:opacity-0', md: 'md:opacity-0', lg: 'lg:opacity-0', xl: 'xl:opacity-0', '2xl': '2xl:opacity-0' },
  25: { default: 'opacity-25', sm: 'sm:opacity-25', md: 'md:opacity-25', lg: 'lg:opacity-25', xl: 'xl:opacity-25', '2xl': '2xl:opacity-25' },
  50: { default: 'opacity-50', sm: 'sm:opacity-50', md: 'md:opacity-50', lg: 'lg:opacity-50', xl: 'xl:opacity-50', '2xl': '2xl:opacity-50' },
  75: { default: 'opacity-75', sm: 'sm:opacity-75', md: 'md:opacity-75', lg: 'lg:opacity-75', xl: 'xl:opacity-75', '2xl': '2xl:opacity-75' },
  100: { default: 'opacity-100', sm: 'sm:opacity-100', md: 'md:opacity-100', lg: 'lg:opacity-100', xl: 'xl:opacity-100', '2xl': '2xl:opacity-100' },
};

const TOP_MAP: Record<string, Record<Breakpoint, string>> = {
  0: { default: 'top-0', sm: 'sm:top-0', md: 'md:top-0', lg: 'lg:top-0', xl: 'xl:top-0', '2xl': '2xl:top-0' },
  4: { default: 'top-4', sm: 'sm:top-4', md: 'md:top-4', lg: 'lg:top-4', xl: 'xl:top-4', '2xl': '2xl:top-4' },
  8: { default: 'top-8', sm: 'sm:top-8', md: 'md:top-8', lg: 'lg:top-8', xl: 'xl:top-8', '2xl': '2xl:top-8' },
  12: { default: 'top-12', sm: 'sm:top-12', md: 'md:top-12', lg: 'lg:top-12', xl: 'xl:top-12', '2xl': '2xl:top-12' },
  16: { default: 'top-16', sm: 'sm:top-16', md: 'md:top-16', lg: 'lg:top-16', xl: 'xl:top-16', '2xl': '2xl:top-16' },
  auto: { default: 'top-auto', sm: 'sm:top-auto', md: 'md:top-auto', lg: 'lg:top-auto', xl: 'xl:top-auto', '2xl': '2xl:top-auto' },
};

const RIGHT_MAP: Record<string, Record<Breakpoint, string>> = {
  0: { default: 'right-0', sm: 'sm:right-0', md: 'md:right-0', lg: 'lg:right-0', xl: 'xl:right-0', '2xl': '2xl:right-0' },
  4: { default: 'right-4', sm: 'sm:right-4', md: 'md:right-4', lg: 'lg:right-4', xl: 'xl:right-4', '2xl': '2xl:right-4' },
  auto: { default: 'right-auto', sm: 'sm:right-auto', md: 'md:right-auto', lg: 'lg:right-auto', xl: 'xl:right-auto', '2xl': '2xl:right-auto' },
};

const BOTTOM_MAP: Record<string, Record<Breakpoint, string>> = {
  0: { default: 'bottom-0', sm: 'sm:bottom-0', md: 'md:bottom-0', lg: 'lg:bottom-0', xl: 'xl:bottom-0', '2xl': '2xl:bottom-0' },
  4: { default: 'bottom-4', sm: 'sm:bottom-4', md: 'md:bottom-4', lg: 'lg:bottom-4', xl: 'xl:bottom-4', '2xl': '2xl:bottom-4' },
  auto: { default: 'bottom-auto', sm: 'sm:bottom-auto', md: 'md:bottom-auto', lg: 'lg:bottom-auto', xl: 'xl:bottom-auto', '2xl': '2xl:bottom-auto' },
};

const LEFT_MAP: Record<string, Record<Breakpoint, string>> = {
  0: { default: 'left-0', sm: 'sm:left-0', md: 'md:left-0', lg: 'lg:left-0', xl: 'xl:left-0', '2xl': '2xl:left-0' },
  4: { default: 'left-4', sm: 'sm:left-4', md: 'md:left-4', lg: 'lg:left-4', xl: 'xl:left-4', '2xl': '2xl:left-4' },
  auto: { default: 'left-auto', sm: 'sm:left-auto', md: 'md:left-auto', lg: 'lg:left-auto', xl: 'xl:left-auto', '2xl': '2xl:left-auto' },
};


const SHOW_ON_MAP = {
  flex: {
    s: 'flex md:hidden',
    m: 'hidden md:flex lg:hidden',
    l: 'hidden lg:flex',
  },
  grid: {
    s: 'grid md:hidden',
    m: 'hidden md:grid lg:hidden',
    l: 'hidden lg:grid',
  }
};



export const getFlexStyles = (
  config:
    | {
        direction?: 'horizontal' | 'vertical';
        gap?: SpacingToken;
        padding?: SpacingToken;
        py?: SpacingToken;
        px?: SpacingToken;
        pt?: SpacingToken;
        pb?: SpacingToken;
        pl?: SpacingToken;
        pr?: SpacingToken;
        m?: SpacingToken;
        my?: SpacingToken;
        mx?: SpacingToken;
        mt?: SpacingToken;
        mb?: SpacingToken;
        align?: ResponsiveProp<'start' | 'center' | 'end' | 'baseline' | 'stretch'>;
        justify?: ResponsiveProp<'start' | 'center' | 'end' | 'between' | 'around' | 'evenly'>;
        fullWidth?: boolean;
        maxWidth?: ResponsiveProp<string>;
        centered?: boolean;
        shadow?: ResponsiveProp<'none' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'inner'>;
        blur?: ResponsiveProp<'none' | 'sm' | 'md' | 'lg' | 'xl'>;
        background?:
          | 'surface'
          | 'primary'
          | 'secondary'
          | 'accent'
          | 'transparent';
        border?: boolean | 'divider' | 'primary' | 'secondary';
        borderRadius?: ResponsiveProp<'none' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full'>;
        position?: ResponsiveProp<'static' | 'fixed' | 'absolute' | 'sticky' | 'relative'>;
        top?: ResponsiveProp<number | string>;
        right?: ResponsiveProp<number | string>;
        bottom?: ResponsiveProp<number | string>;
        left?: ResponsiveProp<number | string>;
        zIndex?: ResponsiveProp<number | string>;
        overflow?: ResponsiveProp<'auto' | 'hidden' | 'visible' | 'scroll'>;
        opacity?: ResponsiveProp<number | string>;
        hideOn?: 's' | 'm' | 'l';
        showOn?: 's' | 'm' | 'l';
        hideOnPrint?: boolean;
        displayGrid?: boolean;
        gridCols?: number | string | ResponsiveCols;
        gridRows?: number | string | ResponsiveCols;
        gapX?: SpacingToken;
        gapY?: SpacingToken;
        width?: string | number;
        height?: string | number;
        display?: string;
      }
    | any,
): string => {
  const isGrid = config.displayGrid;
  const isRow = config.direction === 'horizontal';
  const display = config.display || (isGrid ? 'grid' : 'flex');
  const gridFlow = isGrid
    ? [
        config.gridCols
          ? parseResponsiveCols(config.gridCols, 'grid-cols')
          : '',
        config.gridRows
          ? parseResponsiveCols(config.gridRows, 'grid-rows')
          : '',
      ]
    : [isRow ? 'flex-row' : 'flex-col'];

  return [
    display,
    ...gridFlow,
    parseSpacing(config.gap, 'gap'),
    parseSpacing(config.gapX, 'gap-x'),
    parseSpacing(config.gapY, 'gap-y'),
    parseSpacing(config.padding, 'p'),
    parseSpacing(config.py, 'py'),
    parseSpacing(config.px, 'px'),
    parseSpacing(config.pt, 'pt'),
    parseSpacing(config.pb, 'pb'),
    parseSpacing(config.pl, 'pl'),
    parseSpacing(config.pr, 'pr'),
    parseSpacing(config.m, 'm'),
    parseSpacing(config.my, 'my'),
    parseSpacing(config.mx, 'mx'),
    parseSpacing(config.mt, 'mt'),
    parseSpacing(config.mb, 'mb'),
    parseResponsive(config.maxWidth, MAX_WIDTH_MAP),
    config.centered ? 'mx-auto' : '',
    config.fullWidth ? 'w-full' : '',
    parseResponsive(config.align, ALIGN_MAP),
    parseResponsive(config.justify, JUSTIFY_MAP),
    parseResponsive(config.shadow, SHADOW_MAP),
    parseResponsive(config.blur, BLUR_MAP),
    config.background ? (BACKGROUND_MAP as any)[config.background] || '' : '',
    config.border === true
      ? 'border border-divider'
      : config.border
        ? `border ${(BORDER_MAP as any)[config.border] || ''}`
        : '',
    parseResponsive(config.borderRadius, BORDER_RADIUS_MAP),
    parseResponsive(config.position, POSITION_MAP),
    config.overflow ? parseResponsive(config.overflow, OVERFLOW_MAP) : '',
    config.zIndex !== undefined && config.zIndex !== null && config.zIndex !== '' ? parseResponsive(config.zIndex, Z_INDEX_MAP) : '',
    config.opacity !== undefined && config.opacity !== null && config.opacity !== '' ? parseResponsive(config.opacity, OPACITY_MAP) : '',
    config.top !== undefined && config.top !== null && config.top !== '' ? parseResponsive(config.top, TOP_MAP) : '',
    config.right !== undefined && config.right !== null && config.right !== '' ? parseResponsive(config.right, RIGHT_MAP) : '',
    config.bottom !== undefined && config.bottom !== null && config.bottom !== '' ? parseResponsive(config.bottom, BOTTOM_MAP) : '',
    config.left !== undefined && config.left !== null && config.left !== '' ? parseResponsive(config.left, LEFT_MAP) : '',
    config.hideOn === 's' ? 'max-md:hidden' : '',
    config.hideOn === 'm' ? 'md:hidden lg:block' : '',
    config.hideOn === 'l' ? 'lg:hidden' : '',
    config.showOn ? (SHOW_ON_MAP as any)[display === 'grid' ? 'grid' : 'flex']?.[config.showOn] || '' : '',
    config.hideOnPrint ? 'print:hidden' : '',
  ]
    .filter(Boolean)
    .join(' ');
};
